import type { UserSubscriptionProduct } from "@jti/rest-api-types";

export const getSubscriptionProductsSkus = (subscriptionProducts: UserSubscriptionProduct[] | undefined = []) =>
  subscriptionProducts.reduce((skus: string[], product) => {
    if (skus.indexOf(product.sku) === -1) {
      skus.push(product.sku);
    }

    if (!product?.options?.length) {
      return skus;
    }

    product.options.forEach((option) => {
      const optionIsInSkusList = skus.indexOf(option.sku) > -1;

      if (optionIsInSkusList) {
        return;
      }

      skus.push(option.sku);
    });

    return skus;
  }, []);
